import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field, CccisdCheckboxInput, CccisdSelect, CccisdFieldWrapper } from 'cccisd-formik';
import Modal from 'cccisd-modal';
import Table from 'cccisd-table';
import Tooltip from 'cccisd-tooltip';
import { stripHtml } from 'js/helpers';
import _xor from 'lodash/xor';
import style from './style.css';

const Filters = props => {
    const validate = values => {
        const errors = {};

        return errors;
    };

    const handleSubmit = (values, form, closeModal) => {
        props.setFilters({ ...values });
        closeModal();
    };

    return (
        <Modal
            trigger={
                <Tooltip title="Filter for specific surveys or by status: ready to complete, stopped, completed, and/or archived.">
                    <button type="button" className="btn btn-secondary btn-sm">
                        Filter Options
                    </button>
                </Tooltip>
            }
            title="Filter Options"
            size="large"
            render={({ closeModal }) => (
                <Formik
                    validate={validate}
                    onSubmit={(values, form) => handleSubmit(values, form, closeModal)}
                    initialValues={props.filters}
                >
                    <Form>
                        <div className="d-flex gap-5">
                            <div className="form-check">
                                <label className="form-label">Progress:</label>
                                <Field
                                    name="ready"
                                    component={CccisdCheckboxInput}
                                    label={
                                        <Tooltip title="Shows all assessments that are ready to complete.">
                                            Ready to complete
                                        </Tooltip>
                                    }
                                />
                                <Field
                                    name="stopped"
                                    component={CccisdCheckboxInput}
                                    label={<Tooltip title="Shows all stopped assessments.">Stopped</Tooltip>}
                                />
                                <Field
                                    name="completed"
                                    component={CccisdCheckboxInput}
                                    label={<Tooltip title="Shows all completed assessments.">Completed</Tooltip>}
                                />
                            </div>

                            <Field name="assessments" enableReinitialize>
                                {({ field, form }) => {
                                    return (
                                        <CccisdFieldWrapper field={field} form={form}>
                                            <label className="form-label mb-2">Assessments:</label>
                                            <Modal
                                                size="large"
                                                title="Filter by assessments"
                                                trigger={
                                                    <input
                                                        name="assessments"
                                                        type="text"
                                                        className={`form-select ${style.input}`}
                                                        placeholder="All"
                                                        value={
                                                            props.filters.assessments.size > 0
                                                                ? `${props.filters.assessments.size} selected`
                                                                : 'All'
                                                        }
                                                        onChange={() => {}}
                                                    />
                                                }
                                                render={({ closeModal: closeAssessmentsModal }) => {
                                                    return (
                                                        <div>
                                                            <div className="mb-3 d-flex gap-2">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary btn-xs"
                                                                    onClick={() => {
                                                                        const newAssessments = new Set(
                                                                            props.assessmentList.map(item => item.id)
                                                                        );
                                                                        props.setFilters(prevFilters => {
                                                                            const newFilters = { ...prevFilters };
                                                                            newFilters.assessments = newAssessments;
                                                                            return newFilters;
                                                                        });
                                                                        form.setFieldValue(
                                                                            'assessments',
                                                                            newAssessments
                                                                        );
                                                                    }}
                                                                >
                                                                    Select all
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary btn-xs"
                                                                    onClick={() => {
                                                                        const newAssessments = new Set();
                                                                        props.setFilters(prevFilters => {
                                                                            const newFilters = { ...prevFilters };
                                                                            newFilters.assessments = newAssessments;
                                                                            return newFilters;
                                                                        });
                                                                        form.setFieldValue(
                                                                            'assessments',
                                                                            newAssessments
                                                                        );
                                                                    }}
                                                                >
                                                                    Deselect all
                                                                </button>
                                                            </div>
                                                            <Table
                                                                rowKey="id"
                                                                columns={[
                                                                    {
                                                                        name: 'label',
                                                                        label: 'Assessment',
                                                                        sort: true,
                                                                        filter: true,
                                                                    },
                                                                    {
                                                                        name: 'description',
                                                                        label: 'Description',
                                                                        render: (value, row) => {
                                                                            return stripHtml(value);
                                                                        },
                                                                        sort: true,
                                                                        filter: true,
                                                                    },
                                                                ]}
                                                                data={props.assessmentList}
                                                                showPerPageOptions={false}
                                                                onRowClick={row => {
                                                                    const newAssessments = new Set(
                                                                        _xor([...props.filters.assessments], [row.id])
                                                                    );
                                                                    props.setFilters(prevFilters => {
                                                                        const newFilters = { ...prevFilters };
                                                                        newFilters.assessments = newAssessments;
                                                                        return newFilters;
                                                                    });
                                                                    form.setFieldValue('assessments', newAssessments);
                                                                }}
                                                                showRowClickable
                                                                className="table table-sm table-bordered"
                                                                setRowClass={row => {
                                                                    return props.filters.assessments.has(row.id)
                                                                        ? 'table-primary'
                                                                        : '';
                                                                }}
                                                                saveState={false}
                                                                perPage={10}
                                                            />
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'flex-end',
                                                                    marginTop: '1em',
                                                                }}
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary"
                                                                    onClick={() => {
                                                                        closeAssessmentsModal();
                                                                    }}
                                                                >
                                                                    Close
                                                                </button>
                                                            </div>
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </CccisdFieldWrapper>
                                    );
                                }}
                            </Field>
                            <Field
                                name="archived"
                                component={CccisdSelect}
                                label={<Tooltip title="Show archived assessments">Archived:</Tooltip>}
                                options={[
                                    { value: 'hide', label: 'Hide archived' },
                                    { value: 'show', label: 'Show only archived' },
                                ]}
                                className={`form-select form-select-sm ${style.input}`}
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginTop: '1em',
                            }}
                        >
                            <button type="submit" className="btn btn-primary">
                                Apply Filters
                            </button>
                        </div>
                    </Form>
                </Formik>
            )}
        />
    );
};

Filters.propTypes = {
    assessmentList: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            description: PropTypes.string,
            handle: PropTypes.string,
        })
    ),
    setFilters: PropTypes.func,
    filters: PropTypes.shape({
        ready: PropTypes.bool,
        stopped: PropTypes.bool,
        completed: PropTypes.bool,
        assessments: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        archived: PropTypes.string,
    }),
};

Filters.defaultProps = {};

export default Filters;
